function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M74.499 0H50.144c-6.382 0-14.421.942-21.158 6.49-5.09 4.374-7.566 10.392-7.566 15.828 0 9.211 7.094 18.546 19.625 18.546 1.182 0 2.477-.12 3.787-.235-.592 1.413-1.189 2.594-1.189 4.605 0 3.662 1.893 5.902 3.547 8.029-5.314.353-15.249.942-22.583 5.428-6.975 4.143-9.107 10.16-9.107 14.414C15.499 81.846 23.778 90 40.923 90c20.336 0 31.098-11.22 31.098-22.33 0-8.143-4.729-12.164-9.932-16.534l-4.258-3.305c-1.295-1.065-3.068-2.479-3.068-5.08 0-2.597 1.773-4.254 3.307-5.789 4.964-3.896 9.933-8.03 9.933-16.77 0-8.979-5.68-13.704-8.396-15.947h7.334L74.499 0zM64.103 72.279c0 7.322-6.033 12.753-17.385 12.753-12.648 0-20.809-6.024-20.809-14.405 0-8.393 7.568-11.218 10.166-12.164 4.969-1.656 11.352-1.891 12.414-1.891 1.184 0 1.775 0 2.725.115 8.988 6.377 12.889 9.57 12.889 15.592zm-9.461-38.03c-1.893 1.886-5.088 3.305-8.045 3.305-10.164 0-14.772-13.113-14.772-21.023 0-3.072.592-6.258 2.598-8.74 1.893-2.362 5.201-3.899 8.277-3.899 9.812 0 14.899 13.229 14.899 21.73 0 2.13-.241 5.906-2.957 8.627z",
  "data-original": "#000000",
  className: "google-logo_svg__active-path",
  "data-old_color": "#FCFCFC",
  fill: "#FFF"
});

function SvgGoogleLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 90 90"
  }, props), _ref);
}

export default SvgGoogleLogo;